import { render } from "./SalesBenchmark.vue?vue&type=template&id=16a6fcb2"
import script from "./SalesBenchmark.vue?vue&type=script&lang=js"
export * from "./SalesBenchmark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__